<template>
	<div class="bg-color-content-primary">
		<div class="container marketing-section">
			<div class="ml-auto mr-auto text-align-center-md who-we-are-header mb-300">
				<h1 class="overline text-color-gray-20 text-align-center-md">Who we are</h1>
				<h2 class="heading-1 mt-150 text-color-white">
					The first end-to-end technology platform for alternative investments
				</h2>
				<p class="text-color-white mb-100">
					With close to 400,000 active investors and 2 million users, we believe that Fundrise is, by far, the
					largest private investment platform in the world by number of investors directly in our products,
					and yet has achieved less than a 1% market penetration.
				</p>
			</div>
			<img v-lazy="valueChainImagePath" alt="" role="presentation" class="mb-300" />
			<MarketingSiteCardRow :cards="cards" theme="dark" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { appCloudfrontPath } from '@constants';
import { computed } from 'vue';
import { MarketingSiteCard } from 'types/marketing-site';
import MarketingSiteCardRow from '@components/marketing-site/marketing-site-card-row.vue';
import { useAppStore } from '@stores/app';

const appStore = useAppStore();

const cards: MarketingSiteCard[] = [
	{
		title: 'Distribution',
		description:
			'Through our web and mobile platforms, individuals can access institutional quality alternative investments, without the high-fees and mark-ups associated with traditional channels. Our proprietary payments software processed 2.5 million ACH transactions in 2021 and 3.7 million during 2022, while real-time reporting of return calculations is performed daily for each client account, currently storing over 29.3 billion data points.'
	},
	{
		title: 'Selection',
		description:
			'Our internal software systems allow us to remove the double promote and systematize the back-of-house of accounting, tax, operations and fund operations, including software generating over a million 1099s and K-1s, maintaining 54 million shareholding records, and daily automated transfer agent integration, all at a minimal cost to the investor.'
	},
	{
		title: 'Production',
		description:
			'We’ve revolutionized the asset management process by leveraging modern data infrastructure tools to unlock real time information, automate reporting, and improve decision making across our approximately $6 billion real estate portfolio, which consists of 16,000+ residential units and more than 3 million square feet of commercial space across multifamily, build for rent, urban infill and last-mile industrial asset classes.'
	}
];

const valueChainImagePath = computed((): string => {
	return `${appCloudfrontPath}/images/offerings/fundrise-ipo/end-to-end-diagram-${
		appStore.isMobile ? 'mobile' : 'desktop'
	}.png`;
});
</script>

<style lang="scss">
.who-we-are-header {
	max-width: 45rem;
}
</style>
